import './Home.css';

const Home = () => (
  <>
    <h3 className="heading">Welcome to our page</h3>
    <p className="info">Mathematics is the science that deals with the logic of shape, quantity and arrangement. Math is all around us, in everything we do. It is the building block for everything in our daily lives, including mobile devices, computers, software, architecture (ancient and modern), art, money, engineering and even sports.</p>
  </>
);

export default Home;
